import { render, staticRenderFns } from "./MembersItemsList.vue?vue&type=template&id=567a1ae9&scoped=true&"
import script from "./MembersItemsList.vue?vue&type=script&lang=js&"
export * from "./MembersItemsList.vue?vue&type=script&lang=js&"
import style0 from "./MembersItemsList.vue?vue&type=style&index=0&id=567a1ae9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a1ae9",
  null
  
)

export default component.exports